import md5 from 'blueimp-md5';

export interface GravatarOptions {
  size?: number; // 1..2048
  rating?: 'g' | 'pg' | 'r' | 'x';
  defaultImage?:
    | '404'
    | 'mp'
    | 'identicon'
    | 'monsterid'
    | 'wavatar'
    | 'retro'
    | 'robohash'
    | 'blank'
    | string;
}

/**
 * Build a Gravatar URL from an email (or any string). Email is trimmed and lowercased per Gravatar spec.
 * If the provided value is falsy or not an email, this still yields a deterministic hash; with `defaultImage`
 * like `identicon` users get a generated avatar.
 */
export function gravatarUrl(
  emailOrName: string | null | undefined,
  opts: GravatarOptions = {}
): string {
  const { size = 80, rating = 'r', defaultImage = 'retro' } = opts;
  const normalized = String(emailOrName ?? '')
    .trim()
    .toLowerCase();
  const hash = md5(normalized);
  const params = new URLSearchParams();
  if (size) params.set('s', String(Math.max(1, Math.min(2048, size))));
  if (rating) params.set('r', rating);
  if (defaultImage) params.set('d', defaultImage);
  return `https://www.gravatar.com/avatar/${hash}?${params.toString()}`;
}

export default gravatarUrl;
